module.exports = __webpack_public_path__ + "media/img/illustrations/icons/pay-per-item-b83965507d346d6f27544de06786fd1d.svg";